// 顶层错误 覆盖整个页面
import React, { FC } from 'react';
import styles from './index.module.scss';
import intl from 'react-intl-universal';
import * as service from '@/api/service';
import Button from '@/components/Button';
import { ErrorBoundaryProps, ErrorBoundaryState } from './index';
import common from '@/utils/common';

const TopError: FC<ErrorBoundaryProps & ErrorBoundaryState> = (props) => {
  const { error, errorText = intl.get('ERROR_TOP_DEFAULT_TEXT') } = props;
  // 	5059 领取失败：非公开课程; 5058 领取失败：人数超过上线; 5078  1006 不是本班学生;
  const showAccountSwitch = !common.isClient() && (error?.code !== undefined ? [5058, 5059, 5078, 1006].includes(error.code) : false);
  console.log('error', error);
  // 刷新与重试
  const reload = () => {
    if (!navigator.onLine) return;
    window.location.reload();
  }
  // 退出
  const closeWindow = () => {
    service.closeWindow('CloseWindow', JSON.stringify({}))
  }
  // 切换账号
  const switchAccount = () => {
    common.logout();
  }
  return(
    <div className={styles.topErrorWrap}>
      <div className={styles.errorTips}>
        <img className={styles.errorImg} src={require('@/assets/vod/icon/states_16px_failed.png')}></img>
        <span className={styles.errorText}>{ errorText }</span>
      </div>
      <p className={styles.errorMessage}>{ error?.msg || error?.message || '' }</p>
      <div className={styles.buttonList}>
        {common.isClient() && <Button onClick={closeWindow} type="default">{intl.get('ERROR_CLOSEWINDOW')}</Button>}
        {showAccountSwitch && <Button onClick={switchAccount} type="default">{intl.get('REPLAY_KNOWLEDGE_SWITCH_ACCOUNT')}</Button>}
        <Button onClick={reload} type="primary">{intl.get('ERROR_RENEW')}</Button>
      </div>
    </div>
  )
}

export default TopError;